import { Component, OnInit, Renderer2 } from '@angular/core';
import { AppComponent } from '../app.component';
import { SesionService } from '../common/services/sesion.service';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { RegistroService } from '../registro.service';
import Swal from 'sweetalert2';
import { AccessControlService } from '../access-control/services/access-control.service';
import { UsuarioService } from '../access-control/services/usuario.service';
import { firstValueFrom, Subscription } from 'rxjs';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
    private queryParamsSubscription: Subscription;
    constructor(
        private appComponent: AppComponent,
        private sesionService: SesionService,
        private router: Router,
        private keycloakService: KeycloakService,
        private renderer: Renderer2,
        private registroService: RegistroService,
        private accessControlService: AccessControlService,
        private usuarioService: UsuarioService,
        private route: ActivatedRoute
    ) {
        this.appComponent.descripcionGeneral = '';
        this.renderer.removeClass(document.body, 'layout-top-nav');
    }

    async ngOnInit(): Promise<void> {
        this.queryParamsSubscription = this.route.queryParams.subscribe(
            async (params) => {

                const refresh = params['refresh'];

                await this.cargarDatos();

                if (!refresh) {
                    return;
                }

                await this.alertaComercializador();

                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {},
                    replaceUrl: true,
                });
            }
        );
    }

    private async cargarDatos(): Promise<void> {
        this.registroService.registrado = true;
        await this.obtenerPerfilUsuario();
    }

    async registrarUsuario() {
        const keycloakSub =
            this.keycloakService.getKeycloakInstance().tokenParsed.sub;
        this.usuarioService.registrarUsuario(keycloakSub).subscribe({
            next: (response) => {
                console.log(response);
            },
        });
    }

    async obtenerPerfilUsuario() {
        try {
            const userRol = await this.keycloakService.getUserRoles();
            const agenteVigilado = userRol.find(
                (role) =>
                    role === 'AgenteVigilado' || role === 'Administrador (UPRA)'
            );
            localStorage.setItem('userRol', JSON.stringify(agenteVigilado));
        } catch (error) {
            console.error('Error al cargar el perfil del usuario:', error);
        }
    }

    async validarDatosEmpresa(): Promise<void> {
        const idEmpresa = localStorage.getItem('idEmpresaSeleccionada');

        if (!idEmpresa) {
            console.warn('No hay empresa seleccionada en localStorage');
            return;
        }

        try {
            const response = await firstValueFrom(
                this.registroService.verificarEmpresa(Number(idEmpresa))
            );

            if (response.requiereActualizacion) {
                await Swal.fire({
                    icon: 'info',
                    title: 'Actualización requerida',
                    text: response.mensaje,
                    confirmButtonText: 'Aceptar',
                });
            }
        } catch (err) {
            console.error('Error validando la empresa:', err);
        }
    }

    /**
     * Valida si el eslabon de la empresa es un comercializador puro
     *
     * @param eslabones - Cadena de eslabones separados por '/'
     * @returns `true` si incluye 'Comercializador' y todos los eslabones están permitidos
     *
     */
    validarEslabon(eslabones: string): boolean {
        if (!eslabones) {
            console.warn('No hay eslabones en el localStorage');
            return;
        }
        const permitidos = new Set([
            'Comercializador',
            'Empacador',
            'Envasador',
        ]);
        const partes = eslabones.split('/').map((e) => e.trim());
        return (
            partes.includes('Comercializador') &&
            partes.every((e) => permitidos.has(e))
        );
    }

    /**
     * Genera alerta de información exclusiva para comercializadores
     */
    async alertaComercializador() {
        const esComercializadorPuro = this.validarEslabon(
            this.registroService.eslabonEmpresaSelected
        );

        if (esComercializadorPuro) {
            await Swal.fire({
                icon: 'info',
                title: '⚠️ Atención - Comercializadores',
                text: 'El reporte de información ya está habilitado en Siriiagro. Consulta el correo electrónico registrado para conocer la periodicidad, las instrucciones y las buenas prácticas para el correcto diligenciamiento.',
                confirmButtonText: 'OK',
            });
        }
    }

    ngOnDestroy() {
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }
    }
}
